import { AreaEnum } from "./user";

export type CommonListParams<T = string> = {
  body?: T;
  pagination?: PaginationParams;
  startTime?: number;
  endTime?: number;
  ints?: Array<number>;
  strs?: Array<string>;
  controller?: AbortController;  // ✅ 支持取消请求的 controller
};
export type CommonList = "list" | "fetchs";

export interface PaginationParams {
  offset: number;
  take: number;
  size?: number;
  sort?: number;
}

export interface AccountParams {
  areaCode: AreaEnum | "";
  mobile: string;
  loginOrgId?: string;
}

export interface SecureParams {
  password: string;
}

export enum CommonStateEnum {
  UN_ACTIVE = 0,
  ACTIVE = 1,
}

export interface CustomWindow extends Window {
  config: {
    version: string;
    server_url: string;
    server_name: string;
  };
}

export enum SourceTypeEnum {
  PURCHASE = 1, // 采购订单
  PURCHASE_ITEM, // 采购订单条目
  SALE, // 销售订单
  SALE_ITEM, // 销售订单条目
  IN_STOCK, // 入库单
  IN_STOCK_ITEM, // 入库单条目
  OUT_STOCK, // 出库单
  OUT_STOCK_ITEM, // 出库单条目
  STOCKTAKING, // 盘点单
  STOCKTAKING_ITEM, // 盘点单条目
  RECEIVABLE, // 应收
  RECEIVABLE_ITEM, // 应收条目
  MEET, // 应付
  MEET_ITEM, // 应付条目
  REQUIREMENT, // 需求单
  REQUIREMENT_ITEM, // 需求单条目
  PACK = 31, // 发货单
  SHIPMETN, // 发货单
  SHIPMETN_ITEM, // 发货单条目
}

export enum ItemLabelEnum {
  PURCHASE_ORDER = 1,
  PURCHASE_ORDER_ITEM,
  SALE_ORDER,
  SALE_ORDER_ITEM,
  INBOUND_ORDER,
  INBOUND_ORDER_ITEM,
  OUTBOUND_ORDER,
  OUTBOUND_ORDER_ITEM,
  COUNTING_ORDER,
  COUNTING_ORDER_ITEM,
  ACCEPT,
  ACCEPT_ITEM,
  PATMENT,
  PATMENT_ITEM,
  REQUIREMENT,
  REQUIREMENT_ITEM,
  QUOTATION,
  LOCATION,
  SALE_PRICE,
  SUPPLIER_PRICE,
  PURCHASE_PRICE,
  COUNTING_DIFF,
  USER,
  ORG,
  SUPPLIER,
  BOM,
  PRODUCT_PLAN,
  REQUEST
}

export interface AddTag {
  tag: string;
  refId: string;
  refType: ItemLabelEnum;
}
export interface TagLabel extends AddTag {
  id: string;
};

//用于封装枚举相关数据的hooks
export type EnumOptionsList<T> = {
  key: T;
  value: T;
  color: string;
  label: string;
};